import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-payroll-item-edit-dialog',
  templateUrl: './payroll-item-edit-dialog.component.html',
  styleUrls: ['./payroll-item-edit-dialog.component.scss']
})
export class PayrollItemEditDialogComponent {

  item: any;

  constructor(
    public dialogRef: MatDialogRef<PayrollItemEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.item = { ...data.item };
  }

  save(): void {
    this.dialogRef.close(this.item);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
